// Client-side helpers shared by every "Bulk Import / Export" flow.

/** Read a File into a base64 string (no data: URL prefix). */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
}

/**
 * Count the data rows (excluding the header) in the first sheet of an .xlsx
 * file, for the pre-import confirmation summary. Returns null if the file can't
 * be parsed client-side (the server remains the source of truth).
 */
export async function countXlsxDataRows(file: File): Promise<number | null> {
  try {
    const XLSX = await import("xlsx");
    const buf = await file.arrayBuffer();
    const wb = XLSX.read(buf, { type: "array" });
    const firstSheetName = wb.SheetNames[0];
    if (!firstSheetName) return 0;
    const sheet = wb.Sheets[firstSheetName];
    const aoa = XLSX.utils.sheet_to_json<unknown[]>(sheet, { header: 1, blankrows: false });
    if (aoa.length === 0) return 0;
    // Subtract the header row; count only rows that have at least one value.
    let count = 0;
    for (let i = 1; i < aoa.length; i++) {
      const cells = aoa[i] ?? [];
      if (cells.some((c) => c !== null && c !== undefined && String(c).trim() !== "")) count++;
    }
    return count;
  } catch {
    return null;
  }
}
